import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useTheme } from "@mui/styles";

export const EOCSelect = ({
  cy = "",
  updateF,
  value,
  optionItems,
  clearAble = true,
  isMulti = false,
  listHeight = 150,
  SearchAble = false,
  createAble = false,
}) => {
  const theme = useTheme();
  const style = {
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        boxShadow: "none",
        backgroundColor: value ? "#fff" : "#f5f5f5",
        borderRadius: "0px",
        border: "none",
        borderTopRightRadius: "4px",
        borderTopLeftRadius: "4px",
        borderBottom: isFocused ? "solid " : "solid 1px",
        borderColor: theme.palette.primary.main,
        ":hover": {
          ...styles[":hover"],
          background: "#ccca",
          borderBottom: isFocused ? "solid" : "solid 1px",
          borderColor: theme.palette.secondary.main,
        },
      };
    },
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? theme.palette.primary.light
        : isSelected
        ? theme.palette.primary.main
        : null,
      ":active": { backgroundColor: theme.palette.secondary.light },
    }),
    placeholder: (styles) => ({ ...styles }),
    singleValue: (styles) => ({ ...styles }),
    dropdownIndicator: (styles) => ({ ...styles }),
    menu: (styles) => ({
      ...styles,
      //position: "static",
      zIndex: 9999,
    }),
    menuList: (styles) => ({
      ...styles,

      maxHeight: listHeight + "px",
      overflow: "auto",
    }),
  };
  if (createAble)
    return (
      <span data-cy={"EOCSelect_" + cy}>
        <CreatableSelect
          isMulti={isMulti}
          value={value}
          onChange={updateF}
          autoComplete="off"
          options={optionItems}
          isClearable={clearAble}
          styles={style}
          menuPlacement="auto"
          menuPosition="fixed"
          isSearchable={SearchAble}
          onCreateOption={(e) => {
            updateF({ value: e, label: e });
          }}
        />
      </span>
    );
  return (
    <span data-cy={"EOCSelect_" + cy}>
      <Select
        isMulti={isMulti}
        value={value}
        onChange={updateF}
        autoComplete="off"
        options={optionItems}
        isClearable={clearAble}
        styles={style}
        menuPlacement="auto"
        menuPosition="fixed"
        isSearchable={SearchAble}
      />
    </span>
  );
};

EOCSelect.propTypes = {
  updateF: PropTypes.func.isRequired,
  value: PropTypes.any,
  optionItems: PropTypes.array,
  clearAble: PropTypes.bool,
  isMulti: PropTypes.bool,
  listHeight: PropTypes.number,
};
